<script>
    import {onMount} from 'svelte';

    export let user, params;

    onMount(async () => {
        if (!user || !user.id) {
            if (ENVIRONMENT.DEBUG === 'true') {
                window.location = '/login';
            } else {
                window.location = ENVIRONMENT.API_HOST  + '/external-login';
            }
        }
    });
</script>
<main class="pt-5 text-center">
    {#if user && user.id}
        <h1 class="text-primary">Welcome, {user.name}</h1>
        <p id="select-text" class="pt-3">
            Please select a report at the top menu.
        </p>
    {/if}
</main>

<style>
    #select-text{
        font-size: x-large;
        color: #666;
    }
</style>